import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PrProductService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/pr-products', params);
    }

    configurationErrors(params: any): Observable<any> {
        return super.get('/pr-products/configuration-errors', params);
    }

    store(body: any) {
        return super.post(`/pr-products`, body);
    }

    duplicateContext(prProductId: number): Observable<any> {
        return super.get(`/pr-products/${prProductId}/duplicate-context`);
    }

    duplicate(prProductId: number, body: any): Observable<any> {
        return super.post(`/pr-products/${prProductId}/duplicate`, body);
    }

    show(prProductId: number): Observable<any> {
        return super.get(`/pr-products/${prProductId}`);
    }

    labelLines(prProductId: number): Observable<any> {
        return super.get(`/pr-products/${prProductId}/label-lines`);
    }

    edit(prProductId: number, params: any = {}) {
        return super.get(`/pr-products/${prProductId}/edit`, params);
    }

    stock(prProductId: number) {
        return super.get(`/pr-products/${prProductId}/stock`);
    }

    stockMovementAudits(prProductId: number, params: Record<string, unknown> = {}) {
        return super.get(`/pr-products/${prProductId}/stock-movement-audits`, params);
    }

    update(prProductId: number, body: any) {
        return super.put(`/pr-products/${prProductId}`, body);
    }

    destroy(prProductId: number) {
        return super.delete(`/pr-products/${prProductId}`);
    }

    showBySku(sku: string, params: any = {}): Observable<any> {
        return super.get(`/pr-products/sku/${sku}`, params);
    }

    select(params: any = {}) {
        return super.get(`/pr-products/select`, params);
    }

    unlock(prProductId: number | null) {
        return super.put(`/pr-products/${prProductId}/unlock`, {prProductId});
    }

    updatePart(part: string, prProductId: number | null, body: any) {
        return super.put(`/pr-products/${prProductId}/parts/${part}`, body);
    }

    lastStockRequest(prProductId: number) {
        return super.get(`/pr-products/${prProductId}/stock-requests/last`);
    }

    newStockRequest(prProductId: number) {
        return super.post(`/pr-products/${prProductId}/stock-requests`, {prProductId});
    }

    sendToWms(prProductId: number) {
        return super.post(`/pr-products/${prProductId}/send-to-wms`, {prProductId});
    }

    sendToIntranet(prProductId: number) {
        return super.post(`/pr-products/${prProductId}/send-to-intranet`, {prProductId});
    }

    sendKitToWms(prProductId: number) {
        return super.post(`/pr-products/${prProductId}/send-kit-to-wms`, {prProductId});
    }

    generateInternalAlias(prProductId: number, unitId: number) {
        return super.post(`/pr-products/${prProductId}/units/${unitId}/generate-internal-alias`);
    }

    markets(prProductId: number, params: Record<string, unknown> = {}) {
        return super.get(`/pr-products/${prProductId}/markets`, params);
    }

    priceListLines(prProductId: number, params: Record<string, unknown> = {}) {
        return super.get(`/pr-products/${prProductId}/price-list-lines`, params);
    }

    getWarehouseStock(body: { skus: string[], warehouse_ids: number[] }): Observable<any> {
        return super.post('/pr-products/warehouse-stock', body);
    }
}
